/* Reg lookup - honour the "how far is the port from the box?" answer.
 *
 * Step 2 ("where will you charge?") and step 3 ("how far is the port from the
 * box?") of the homepage fit-finder were decorative. The buttons toggled
 * `is-selected` and the value went nowhere: no script on the site contained
 * the word "distance", the lookup request carries only ?reg=, and the worker
 * returns a fixed 5M / 32amp (7.2kW) variant every time. A customer who
 * answered "20m+" was sent to a five-metre cable - on a product that stocks
 * 5M, 10M, 15M and 20M, all in stock.
 *
 * The worker is the right long-term home for this, but the theme already has
 * everything it needs: the worker's own link carries the product handle, and
 * Shopify will hand us that product's variants. So we read the answer and
 * repoint the link at the variant that actually matches.
 *
 * Deliberately conservative about WHICH variant: cable type and amperage are
 * the worker's decisions and are preserved exactly. Only the length option is
 * allowed to move, and only to a length that is genuinely in stock - nearest
 * wins if the exact one is not. If anything is missing or unrecognisable the
 * link is left completely alone, so the worst case is today's behaviour.
 *
 * Loaded alongside reg-lookup.js from snippets/reg-lookup-form.liquid, which
 * renders more than once on some pages, so this guards against double-init.
 */
(function () {
  'use strict';

  if (window.__evchRegLength) return;
  window.__evchRegLength = true;

  /* What each answer means in metres. "Not sure" resolves to 10m rather than
     being left alone: 10m is what the site's own buying guides call the right
     default for most UK homes, and leaving it alone means the 5m the worker
     already picked. */
  var METRES = { '<5m': 5, '5-10m': 10, '10-20m': 15, '20m+': 20, 'Not sure': 10 };

  function chosenMetres() {
    var b = document.querySelector('.opt-distance.is-selected');
    if (!b) return null;
    var key = b.getAttribute('data-distance');
    return Object.prototype.hasOwnProperty.call(METRES, key) ? METRES[key] : null;
  }

  /* Which of the variant's options holds the length. Found by shape rather
     than by position, so a product that orders its options differently still
     works. */
  function lengthIndex(variant) {
    var opts = variant && variant.options ? variant.options : [];
    for (var i = 0; i < opts.length; i++) {
      if (/^\s*\d+(?:\.\d+)?\s*m\s*$/i.test(opts[i])) return i;
    }
    return -1;
  }

  function metresOf(variant, i) {
    return parseFloat(String(variant.options[i]).replace(/[^\d.]/g, ''));
  }

  var cache = {};
  function loadProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function retarget(anchor, metres) {
    if (anchor.getAttribute('data-length-applied') === String(metres)) return;

    var href = anchor.getAttribute('href') || '';
    var handle = /\/products\/([^/?#]+)/.exec(href);
    if (!handle) return;
    var current = /[?&]variant=(\d+)/.exec(href);

    loadProduct(handle[1]).then(function (p) {
      if (!p || !p.variants || !p.variants.length) return;

      var base = null;
      if (current) {
        base = p.variants.filter(function (v) { return String(v.id) === current[1]; })[0] || null;
      }
      if (!base) {
        base = p.variants.filter(function (v) { return v.available; })[0] || null;
      }
      if (!base) return;

      var li = lengthIndex(base);
      if (li < 0) return;

      /* Same cable in every respect except how long it is. */
      var pool = p.variants.filter(function (v) {
        if (!v.available || lengthIndex(v) !== li) return false;
        for (var i = 0; i < v.options.length; i++) {
          if (i !== li && v.options[i] !== base.options[i]) return false;
        }
        return true;
      });
      if (!pool.length) return;

      pool.sort(function (a, b) {
        return Math.abs(metresOf(a, li) - metres) - Math.abs(metresOf(b, li) - metres);
      });
      var best = pool[0];

      anchor.setAttribute('href', p.url + '?variant=' + best.id);
      anchor.setAttribute('data-length-applied', String(metres));

      /* Say which length they are being sent to, so the answer visibly did
         something. Replaces its own suffix rather than stacking them up when
         the answer is changed again. */
      var picked = String(best.options[li]).toUpperCase();
      var label = anchor.textContent.replace(/\s+·\s+\d+(?:\.\d+)?M\s*$/i, '').trim();
      anchor.textContent = label + ' · ' + picked;
    });
  }

  function apply(root) {
    var metres = chosenMetres();
    if (!metres) return;
    var links = (root || document).querySelectorAll('.reg-result-actions a[href*="/products/"]');
    Array.prototype.forEach.call(links, function (a) { retarget(a, metres); });
  }

  /* The result region is rewritten wholesale by reg-lookup.js on every lookup
     and on every purpose change, so watch it rather than hooking the submit. */
  function watch() {
    var regions = document.querySelectorAll('[data-reg-result]');
    Array.prototype.forEach.call(regions, function (r) {
      if (r.getAttribute('data-length-watch')) return;
      r.setAttribute('data-length-watch', '1');
      apply(r);
      if (!window.MutationObserver) return;
      new MutationObserver(function () { apply(r); })
        .observe(r, { childList: true, subtree: true });
    });
  }

  /* Changing the answer after a result is on screen re-points the link. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.opt-distance')) return;
    setTimeout(function () {
      var done = document.querySelectorAll('.reg-result-actions a[data-length-applied]');
      Array.prototype.forEach.call(done, function (a) { a.removeAttribute('data-length-applied'); });
      apply(document);
    }, 30);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  document.addEventListener('shopify:section:load', watch);
})();